<template>
  <!--
    	作者：gmshop
    	时间：2019-10-25
    	描述：组件-选择服务
    -->
  <div class="marketing-box">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="服务名称">
          <el-input v-model="formInline.name" placeholder="请输入服务名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column prop="id" label="服务id" width="70"></el-table-column>
          <el-table-column label="缩略图" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.image" v-img-url="scope.row.image.file_path" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="服务名称"></el-table-column>
          <el-table-column type="selection" :selectable="selectableFunc" width="44" v-if="islist"></el-table-column>
          <el-table-column width="80" label="单选" v-if="!islist">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
              <el-button size="mini" v-else disabled>已选</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[2, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DataApi from '@/api/data.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*搜索表单对象*/
      formInline: {
        name: '',
      },
      /*列表*/
      tableData: [],
      /*选中的*/
      multipleSelection: [],
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: {
    islist :{
      default: false,
      type: Boolean,
    },
    excludeIds :{
      default: ()=>[],
      type: Array
    },
  },
  created() {
    this.chooseList();
    this.getTableList()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取数据*/
    getTableList() {
      let self = this;
      self.loading = true;
      let params = self.formInline;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      DataApi.getService(params,true).then(data => {
          self.loading = false;
          /*判断是否需要去重*/
            if(self.excludeIds&&typeof(self.excludeIds)!='undefined'&&self.excludeIds.length>0){
              data.data.list.data.forEach(item=>{
                if(self.excludeIds.indexOf(item.id)>-1){
                  item.noChoose=false;
                }else{
                  item.noChoose=true;
                }
              });
            }else{
              if(!self.islist){
                 data.data.list.data.forEach(item=>{
                   item.noChoose=true;
                 });
              }
            }
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*查询*/
    search() {
      this.curPage = 1;
      this.tableData = [];
      this.getTableList();
    },

    /*监听单选按钮选中事件*/
    selectUser(val) {
      this.multipleSelection = val;
      this.confirmFunc();
    },

    
    /*是否可以勾选*/
    selectableFunc(e){
      if(typeof e.noChoose !=='boolean'){
        return true;
      }
      return e.noChoose;
    },

    /*选择服务*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    
    /*单选*/
    SingleFunc(row){
      this.multipleSelection=[row];
      this.addClerk();
    },

    //点击确定
    addClerk() {
      let self = this;
      let params = null;
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请选择服务！',
          type: 'error'
        });
        return;
      }
      if (self.islist&&typeof(self.islist)!='undefined') {
        // self.multipleSelection.forEach(item=>{
        //   item.image=item.product.image[0].file_path;
        //   item.product_name=item.product.product_name;
        //   item.point_num=item.sku[0].point_num;
        //   item.point_money=item.sku[0].point_money;
        // });
        params = self.multipleSelection;
      } else {
        params = self.multipleSelection[0];
        let obj = {};
        obj.name = params.name;
        obj.url = 'application/reservation/details/details?id=' + params.id;
        obj.type = '服务详情';
        this.$emit('changeData', obj);
      }
      self.type='success';
      
    },
    chooseList() {
      this.$emit('changeData', {
        name:'服务列表',
        type:'服务详情',
        url: 'application/reservation/list/list',
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/setlink/part/Service.vue